import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate } from '@tyler-components-web/core';
import { FOOTER_ITEM_CONSTANTS } from './footer-item-constants';
var defaultTemplate = require('./footer-item.html');
var styles = require('./footer-item.css');
/**
 * The custom element class behind the `<tcw-footer-item>` element.
 */
var FooterItemComponent = /** @class */ (function (_super) {
    __extends(FooterItemComponent, _super);
    function FooterItemComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, FOOTER_ITEM_CONSTANTS.elementName, defaultTemplate, styles);
        return _this;
    }
    FooterItemComponent.prototype.connectedCallback = function () {
        this._setRole();
    };
    FooterItemComponent.prototype._setRole = function () {
        if (!this.hasAttribute('role')) {
            this.setAttribute('role', 'listitem');
        }
    };
    FooterItemComponent = __decorate([
        CustomElement({
            name: FOOTER_ITEM_CONSTANTS.elementName
        })
    ], FooterItemComponent);
    return FooterItemComponent;
}(HTMLElement));
export { FooterItemComponent };
